import { LoginParams, LoginResult } from "../model/User";
import apiCaller from "./axios.service";

const baseUrl: string = "/v1/public/seamlessIdentity";

export const seamlessSignIn = async (
	data: LoginParams
): Promise<LoginResult> => {
	return apiCaller(`${baseUrl}/seamlessSignIn`, data);
};

export const seamlessSignOut = () => {
	return apiCaller(`${baseUrl}/seamlessSignOut`);
};
